import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsMoneySourceWidgetVisibleInSummary } from '../../../selectors/elementsVisibility';
import { selectAvailableMoneySources } from '../../../reducers/v2/moneySources/selectors';
import { setPlacingMoneySource } from '../../../actions/publishTerms';
import { loadPublishTerms } from '../../../thunks/publishTerms/loadPublishTerms';
import { EMoneySource } from '../../../types/reducers/user';

import { IUseMoneySource } from '../types';
import { getOptions, getWidgetType } from './utils';
import { useMoneySourceAnalytics } from './useMoneySourceAnalytics';
import { selectIsSubagent } from '../../../reducers/v2/user/selectors';

export const useMoneySource = (): IUseMoneySource => {
  const dispatch = useDispatch();

  const { trackMoneySourceClick } = useMoneySourceAnalytics();

  const isWidgetInSummary = useSelector(selectIsMoneySourceWidgetVisibleInSummary);
  const sources = useSelector(selectAvailableMoneySources);
  const isSubagent = useSelector(selectIsSubagent);

  const widgetType = getWidgetType(isWidgetInSummary);

  const handleChange = useCallback(
    (value: EMoneySource) => {
      dispatch(setPlacingMoneySource(value));
      dispatch(loadPublishTerms());

      trackMoneySourceClick(value);
    },
    [dispatch, trackMoneySourceClick],
  );

  const options = useMemo(() => getOptions({ sources, widgetType }), [sources, widgetType]);

  return { isRender: isSubagent, widgetType, options, onChange: handleChange };
};
